export default __webpack_public_path__ + "static/logo-ab2da242d2cccfa8b815b056a2fe76cf.png";